export const FETCH_APARTMENTDATA_INIT_ACTION =
  "FETCH_APARTMENTDATA_INIT_ACTION";
export const FETCH_APARTMENTDATA_SUCCESS_ACTION =
  FETCH_APARTMENTDATA_INIT_ACTION + "_SUCCESS";
export const FETCH_APARTMENTDATA_FAIL_ACTION =
  FETCH_APARTMENTDATA_INIT_ACTION + "_ERROR";

export const FETCH_APARTMENTAPPUSERDATA_INIT_ACTION =
  "FETCH_APARTMENTAPPUSERDATA_INIT_ACTION";
export const FETCH_APARTMENTAPPUSERDATA_SUCCESS_ACTION =
  FETCH_APARTMENTAPPUSERDATA_INIT_ACTION + "_SUCCESS";
export const FETCH_APARTMENTAPPUSERDATA_FAIL_ACTION =
  FETCH_APARTMENTAPPUSERDATA_INIT_ACTION + "_ERROR";

export const ADD_APARTMENTAPPUSERDATA_INIT_ACTION =
  "ADD_APARTMENTAPPUSERDATA_INIT_ACTION";
export const ADD_APARTMENTAPPUSERDATA_SUCCESS_ACTION =
  ADD_APARTMENTAPPUSERDATA_INIT_ACTION + "_SUCCESS";
export const ADD_APARTMENTAPPUSERDATA_FAIL_ACTION =
  ADD_APARTMENTAPPUSERDATA_INIT_ACTION + "_ERROR";

export const DELETE_APARTMENTAPPUSERDATA_INIT_ACTION =
  "DELETE_APARTMENTAPPUSERDATA_INIT_ACTION";
export const DELETE_APARTMENTAPPUSERDATA_SUCCESS_ACTION =
  DELETE_APARTMENTAPPUSERDATA_INIT_ACTION + "_SUCCESS";
export const DELETE_APARTMENTAPPUSERDATA_FAIL_ACTION =
  DELETE_APARTMENTAPPUSERDATA_INIT_ACTION + "_ERROR";

export const UPDATE_APARTMENTAPPUSERDATA_INIT_ACTION =
  "UPDATE_APARTMENTAPPUSERDATA_INIT_ACTION";
export const UPDATE_APARTMENTAPPUSERDATA_SUCCESS_ACTION =
  UPDATE_APARTMENTAPPUSERDATA_INIT_ACTION + "_SUCCESS";
export const UPDATE_APARTMENTAPPUSERDATA_FAIL_ACTION =
  UPDATE_APARTMENTAPPUSERDATA_INIT_ACTION + "_ERROR";

export const DELETE_APARTMENTAPPUSERDATA_CHECK_INIT_ACTION =
  "DELETE_APARTMENTAPPUSERDATA_CHECK_INIT_ACTION";
export const DELETE_APARTMENTAPPUSERDATA_CHECK_SUCCESS_ACTION =
  DELETE_APARTMENTAPPUSERDATA_CHECK_INIT_ACTION + "_SUCCESS";
export const DELETE_APARTMENTAPPUSERDATA_CHECK_FAIL_ACTION =
  DELETE_APARTMENTAPPUSERDATA_CHECK_INIT_ACTION + "_ERROR";

//Collection

export const GENERATE_COLLECTION_INIT_ACTION =
  "GENERATE_COLLECTION_INIT_ACTION";
export const GENERATE_COLLECTION_SUCCESS_ACTION =
  GENERATE_COLLECTION_INIT_ACTION + "_SUCCESS";
export const GENERATE_COLLECTION_FAIL_ACTION =
  GENERATE_COLLECTION_INIT_ACTION + "_ERROR";

export const FETCH_COLLECTIONISMAILSENT_INIT_ACTION =
  "FETCH_COLLECTION_INIT_ACTION";
export const FETCH_COLLECTIONISMAILSENT_SUCCESS_ACTION =
  FETCH_COLLECTIONISMAILSENT_INIT_ACTION + "_SUCCESS";
export const FETCH_COLLECTIONISMAILSENT_FAIL_ACTION =
  FETCH_COLLECTIONISMAILSENT_INIT_ACTION + "_ERROR";

export const FETCH_REGENERATE_INIT_ACTION = "FETCH_REGENERATE_INIT_ACTION";
export const FETCH_REGENERATE_SUCCESS_ACTION =
  FETCH_REGENERATE_INIT_ACTION + "_SUCCESS";
export const FETCH_REGENERATE_FAIL_ACTION =
  FETCH_REGENERATE_INIT_ACTION + "_ERROR";

export const FETCH_COLLECTIONDATA_INIT_ACTION =
  "FETCH_COLLECTIONDATA_INIT_ACTION";
export const FETCH_COLLECTIONDATA_SUCCESS_ACTION =
  FETCH_COLLECTIONDATA_INIT_ACTION + "_SUCCESS";
export const FETCH_COLLECTIONDATA_FAIL_ACTION =
  FETCH_COLLECTIONDATA_INIT_ACTION + "_ERROR";

export const ADD_REGWATERCARD_INIT_ACTION = "ADD_REGWATERCARD_INIT_ACTION";
export const ADD_REGWATERCARD_SUCCESS_ACTION =
  ADD_REGWATERCARD_INIT_ACTION + "_SUCCESS";
export const ADD_REGWATERCARD_FAIL_ACTION =
  ADD_REGWATERCARD_INIT_ACTION + "_ERROR";

export const ADD_GENERATE_WATERCARD_INIT_ACTION =
  "ADD_GENERATE_WATERCARD_INIT_ACTION";
export const ADD_GENERATE_WATERCARD_SUCCESS_ACTION =
  ADD_GENERATE_WATERCARD_INIT_ACTION + "_SUCCESS";
export const ADD_GENERATE_WATERCARD_FAIL_ACTION =
  ADD_GENERATE_WATERCARD_INIT_ACTION + "_ERROR";

export const ADD_COLLECTION_PAYMENTS_INIT_ACTION =
  "ADD_COLLECTION_PAYMENTS_INIT_ACTION";
export const ADD_COLLECTION_PAYMENTS_SUCCESS_ACTION =
  ADD_COLLECTION_PAYMENTS_INIT_ACTION + "_SUCCESS";
export const ADD_COLLECTION_PAYMENTS_FAIL_ACTION =
  ADD_COLLECTION_PAYMENTS_INIT_ACTION + "_ERROR";

export const FETCH_COLLECTION_APARTMENTS_INIT_ACTION =
  "FETCH_COLLECTION_APARTMENTS_INIT_ACTION";
export const FETCH_COLLECTION_APARTMENTS_SUCCESS_ACTION =
  FETCH_COLLECTION_APARTMENTS_INIT_ACTION + "_SUCCESS";
export const FETCH_COLLECTION_APARTMENTS_FAIL_ACTION =
  FETCH_COLLECTION_APARTMENTS_INIT_ACTION + "_ERROR";

export const FETCH_DOWNLOAD_WATER_CARD_INIT_ACTION =
  "FETCH_DOWNLOAD_WATER_CARD_INIT_ACTION";
export const FETCH_DOWNLOAD_WATER_CARD_SUCCESS_ACTION =
  FETCH_DOWNLOAD_WATER_CARD_INIT_ACTION + "_SUCCESS";
export const FETCH_DOWNLOAD_WATER_CARD_FAIL_ACTION =
  FETCH_DOWNLOAD_WATER_CARD_INIT_ACTION + "_ERROR";

export const CONSOLIDATED_BILL_VIEW_INIT_ACTION =
  "CONSOLIDATED_BILL_VIEW_INIT_ACTION";
export const CONSOLIDATED_BILL_VIEW_SUCCESS_ACTION =
  CONSOLIDATED_BILL_VIEW_INIT_ACTION + "_SUCCESS";
export const CONSOLIDATED_BILL_VIEW_FAIL_ACTION =
  CONSOLIDATED_BILL_VIEW_INIT_ACTION + "_ERROR";

export const FETCH_PENDING_BILLS_INIT_ACTION =
  "FETCH_PENDING_BILLS_INIT_ACTION";
export const FETCH_PENDING_BILLS_SUCCESS_ACTION =
  FETCH_PENDING_BILLS_INIT_ACTION + "_SUCCESS";
export const FETCH_PENDING_BILLS_FAIL_ACTION =
  FETCH_PENDING_BILLS_INIT_ACTION + "_ERROR";

export const FETCH_INTERIM_BILLS_INIT_ACTION =
  "FETCH_INTERIM_BILLS_INIT_ACTION";
export const FETCH_INTERIM_BILLS_SUCCESS_ACTION =
  FETCH_INTERIM_BILLS_INIT_ACTION + "_SUCCESS";
export const FETCH_INTERIM_BILLS_FAIL_ACTION =
  FETCH_INTERIM_BILLS_INIT_ACTION + "_ERROR";

//Consumption

export const FETCH_METER_WISE_CONSUMPTION_INIT_ACTION =
  "FETCH_METER_WISE_CONSUMPTION_INIT_ACTION";
export const FETCH_METER_WISE_CONSUMPTION_SUCCESS_ACTION =
  FETCH_METER_WISE_CONSUMPTION_INIT_ACTION + "_SUCCESS";
export const FETCH_METER_WISE_CONSUMPTION_FAIL_ACTION =
  FETCH_METER_WISE_CONSUMPTION_INIT_ACTION + "_ERROR";

// ***************************valve Control************************

export const FETCH_VALVE_CONTROL_DATA_INIT_ACTION =
  "FETCH_VALVE_CONTROL_DATA_INIT_ACTION";
export const FETCH_VALVE_CONTROL_DATA_SUCCESS_ACTION =
  FETCH_VALVE_CONTROL_DATA_INIT_ACTION + "_SUCCESS";
export const FETCH_VALVE_CONTROL_DATA_FAIL_ACTION =
  FETCH_VALVE_CONTROL_DATA_INIT_ACTION + "_ERROR";

export const UPDATE_VALVE_CONTROL_ACTION_INIT_ACTION =
  "UPDATE_VALVE_CONTROL_ACTION_INIT_ACTION";
export const UPDATE_VALVE_CONTROL_ACTION_SUCCESS_ACTION =
  UPDATE_VALVE_CONTROL_ACTION_INIT_ACTION + "_SUCCESS";
export const UPDATE_VALVE_CONTROL_ACTION_FAIL_ACTION =
  UPDATE_VALVE_CONTROL_ACTION_INIT_ACTION + "_ERROR";

export const UPDATE_CLOSE_ALL_VALVE_INIT_ACTION =
  "UPDATE_CLOSE_ALL_VALVE_INIT_ACTION";
export const UPDATE_CLOSE_ALL_VALVE_SUCCESS_ACTION =
  UPDATE_CLOSE_ALL_VALVE_INIT_ACTION + "_SUCCESS";
export const UPDATE_CLOSE_ALL_VALVE_FAIL_ACTION =
  UPDATE_CLOSE_ALL_VALVE_INIT_ACTION + "_ERROR";

// ***************************Admin Lock************************

export const UPDATE_ADMIN_LOCK_INIT_ACTION = " UPDATE_ADMIN_LOCK_INIT_ACTION";
export const UPDATE_ADMIN_LOCK_SUCCESS_ACTION =
  UPDATE_ADMIN_LOCK_INIT_ACTION + "_SUCCESS";
export const UPDATE_ADMIN_LOCK_FAIL_ACTION =
  UPDATE_ADMIN_LOCK_INIT_ACTION + "_ERROR";

export const FETCH_COLLECTION_REPORT_AUTO_GENERATE_INIT_ACTION =
  "FETCH_COLLECTION_REPORT_AUTO_GENERATE_INIT_ACTION";
export const FETCH_COLLECTION_REPORT_AUTO_GENERATE_SUCCESS_ACTION =
  FETCH_COLLECTION_REPORT_AUTO_GENERATE_INIT_ACTION + "_SUCCESS";
export const FETCH_COLLECTION_REPORT_AUTO_GENERATE_FAIL_ACTION =
  FETCH_COLLECTION_REPORT_AUTO_GENERATE_INIT_ACTION + "_ERROR";

//**********************************View Pdf Card ************************/
//viewAptBillCompact

export const FETCH_VIEW_BILL_COMPACT_INIT_ACTION =
  "FETCH_VIEW_BILL_COMPACT_INIT_ACTION";
export const FETCH_VIEW_BILL_COMPACT_SUCCESS_ACTION =
  FETCH_VIEW_BILL_COMPACT_INIT_ACTION + "_SUCCESS";
export const FETCH_VIEW_BILL_COMPACT_FAIL_ACTION =
  FETCH_VIEW_BILL_COMPACT_INIT_ACTION + "_ERROR";

//getTemplate

export const FETCH_TEMPLATE_INIT_ACTION = "FETCH_TEMPLATE_INIT_ACTION";
export const FETCH_TEMPLATE_SUCCESS_ACTION =
  FETCH_TEMPLATE_INIT_ACTION + "_SUCCESS";
export const FETCH_TEMPLATE_FAIL_ACTION = FETCH_TEMPLATE_INIT_ACTION + "_ERROR";

//sendaptemail

export const SEND_APARTMENT_EMAIL_INIT_ACTION =
  "SEND_APARTMENT_EMAIL_INIT_ACTION";
export const SEND_APARTMENT_EMAIL_SUCCESS_ACTION =
  SEND_APARTMENT_EMAIL_INIT_ACTION + "_SUCCESS";
export const SEND_APARTMENT_EMAIL_FAIL_ACTION =
  SEND_APARTMENT_EMAIL_INIT_ACTION + "_ERROR";

export const SEND_RESIDENT_EMAIL_INIT_ACTION =
  "SEND_RESIDENT_EMAIL_INIT_ACTION";
export const SEND_RESIDENT_EMAIL_SUCCESS_ACTION =
  SEND_RESIDENT_EMAIL_INIT_ACTION + "_SUCCESS";
export const SEND_RESIDENT_EMAIL_FAIL_ACTION =
  SEND_RESIDENT_EMAIL_INIT_ACTION + "_ERROR";

export const FETCH_VALVE_HISTORY_INIT_ACTION =
  "FETCH_VALVE_HISTORY_INIT_ACTION";
export const FETCH_VALVE_HISTORY_SUCCESS_ACTION =
  FETCH_VALVE_HISTORY_INIT_ACTION + "_SUCCESS";
export const FETCH_VALVE_HISTORY_FAIL_ACTION =
  FETCH_VALVE_HISTORY_INIT_ACTION + "_ERROR";

export const UPDATE_COLLECTION_PAYMENTS_INIT_ACTION =
  "UPDATE_COLLECTION_PAYMENTS_INIT_ACTION";
export const UPDATE_COLLECTION_PAYMENTS_SUCCESS_ACTION =
  UPDATE_COLLECTION_PAYMENTS_INIT_ACTION + "_SUCCESS";
export const UPDATE_COLLECTION_PAYMENTS_FAIL_ACTION =
  UPDATE_COLLECTION_PAYMENTS_INIT_ACTION + "_ERROR";

export const FETCH_APARTMENTBYID_INIT_ACTION =
  "FETCH_APARTMENTBYID_INIT_ACTION";
export const FETCH_APARTMENTBYID_SUCCESS_ACTION =
  FETCH_APARTMENTBYID_INIT_ACTION + "_SUCCESS";
export const FETCH_APARTMENTBYID_FAIL_ACTION =
  FETCH_APARTMENTBYID_INIT_ACTION + "_ERROR";

export const UPDATE_RESIDENTDATA_INIT_ACTION =
  "UPDATE_RESIDENTDATA_INIT_ACTION";
export const UPDATE_RESIDENTDATA_SUCCESS_ACTION =
  UPDATE_RESIDENTDATA_INIT_ACTION + "_SUCCESS";
export const UPDATE_RESIDENTDATA_FAIL_ACTION =
  UPDATE_RESIDENTDATA_INIT_ACTION + "_ERROR";

export const DELETE_COLLECTION_PAYMENTS_INIT_ACTION =
  "DELETE_COLLECTION_PAYMENTS_INIT_ACTION";
export const DELETE_COLLECTION_PAYMENTS_SUCCESS_ACTION =
  DELETE_COLLECTION_PAYMENTS_INIT_ACTION + "_SUCCESS";
export const DELETE_COLLECTION_PAYMENTS_FAIL_ACTION =
  DELETE_COLLECTION_PAYMENTS_INIT_ACTION + "_ERROR";
